import type { User } from "../types/User";
import { canAccessDialplanBot, canAccessDialplanOverview } from "./dialplanAccess";
import { isSuperAdminRole } from "./userRoles";

export const getHiddenPageIds = (user: User | null | undefined): Set<string> => {
  const hiddenPages = new Set(
    Array.isArray(user?.tenant?.hiddenPages) ? user.tenant.hiddenPages : []
  );
  const isSuperAdmin = isSuperAdminRole(user?.role);
  const hasDialplanOverviewAccess = canAccessDialplanOverview(user?.role);
  const showRedirectNumbers =
    user?.tenant?.showRedirectNumbers === true ||
    String(user?.tenant?.showRedirectNumbers) === "true";

  if (isSuperAdmin) {
    hiddenPages.delete("twilio-numbers");
    hiddenPages.delete("tickets");
  } else {
    hiddenPages.add("twilio-numbers");
  }

  if (!canAccessDialplanBot(user?.role, user?.tenant)) {
    hiddenPages.add("dialplan-bot");
  } else {
    hiddenPages.delete("dialplan-bot");
  }

  if (!hasDialplanOverviewAccess) {
    hiddenPages.add("dialplan-overview");
  }

  if (!showRedirectNumbers) {
    hiddenPages.add("redirect-numbers");
  }

  return hiddenPages;
};

export const canAccessPage = (
  pageId: string,
  user: User | null | undefined
): boolean => !getHiddenPageIds(user).has(pageId);
